import { render, staticRenderFns } from "./VPSPwdLessOtpDelivery.vue?vue&type=template&id=39cd92ca&scoped=true"
import script from "./VPSPwdLessOtpDelivery.vue?vue&type=script&lang=js"
export * from "./VPSPwdLessOtpDelivery.vue?vue&type=script&lang=js"
import style0 from "./VPSPwdLessOtpDelivery.vue?vue&type=style&index=0&id=39cd92ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cd92ca",
  null
  
)

export default component.exports